module.exports = __webpack_public_path__ + "img/习城乡-c.8381920a.png";